<div id="core">
    <div class="modal-header">
        <h2 class="modal-title" translate>lblViewDocument</h2>
        <button type="button" class="close" aria-label="Close" (click)="OnClose()">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th style="width: 30px" scope="col" class="pr-0"> </th>
                    <th translate>lblNo</th>
                    <th translate>lblDemand</th>
                    <th style="width:120px" translate>lblDownloadAll</th>
                </tr>
            </thead>
            <tbody>
                <ng-container>
                    <tr [ngClass]="{'bg-info': expandedDemandDoc}" style="cursor: pointer;">
                        <td style="width:30px" class="pr-0" (click)="OnDemandExpand()">
                            <a ngbTooltip="{{'lblShowDemandDocuments' | translate}}" tooltipClass="custom-revert">
                                <em class="fas fa-chevron-right fa-lg"
                                    [ngClass]="{'fa-chevron-up': expandedDemandDoc}"></em>
                            </a>
                        </td>
                        <td>{{viewDemandDocument.demandNo}}</td>
                        <td>{{viewDemandDocument.demandName}}</td>
                        <td class="text-center">
                            <!-- download multiple -->
                            <a class="btn btn-primary" (click)="downloadFile('', true)" *ngIf="expandedDemandDoc">
                                <em class="fas fa-download fa-lg"
                                    ngbTooltip="{{'lblDownloadAll' | translate}}"></em>
                            </a>

                        </td>

                    </tr>
                </ng-container>
                <ng-template #load_else>
                    <tr>
                        <td colspan="8" translate>lblNoRecordsFound</td>
                    </tr>
                </ng-template>
            </tbody>
        </table>
        <ng-container *ngIf="expandedDemandDoc">
            <div class="d-flex justify-content-center pb-3">
                <div id="carouselExampleControls" class="carousel slide m-0 img-slider" data-bs-ride="carousel">
                    <div class="carousel-inner1 click">
                        <div class="inner">
                            <div class="carousel-item active border" style="display: inline-block;width:500px;">
                                <img [src]='imageToShow' class="d-block p-1" alt="" id="imageToShow" />
                            </div>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev" (click)="Previous()">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden"></span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="next" (click)="next()">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden"></span>
                    </button>
                </div>
                <div class="w0">
                    <button class="btn btn-outline-primary r-left-none" (click)="downloadFile(imageToOpen, false)">
                        <em class="fas fa-download fa-lg" ngbTooltip="{{'lblDownload' | translate}}" translate></em>
                    </button>
                    <button [disabled]="(((documentSourceId == 2 || documentSourceId == 4) && requestApplication == 1) || ((requestApplication == 2 || requestApplication == 4) && documentSourceId == 1))" class="btn btn-outline-primary r-left-none" (click)="deleteSingleDocument(AppointmentFileName, AppointmentId, documentId)">
                        <em class="far fa-trash-alt fa-lg"  [ngbTooltip]="(((documentSourceId == 2 || documentSourceId == 4) && requestApplication == 1) || ((requestApplication == 2 || requestApplication == 4) && documentSourceId == 1)) ? ('lblNotAllowedToDeleteDocument' | translate) : ('lblDelete' | translate)"></em>
                    </button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="expandedDemandDoc">
            <div class="d-block mt-2 bg-light border p-3 maxw-500 mx-auto" id="commentview">
                <p class="text-dark font-bold" translate>lblComment</p>
                <em class="font18 font-style-italic font-weight-bold">
                    " {{documentComment}} "
                </em>
                <p class="text-right font-weight-bold">
                    ~ <ngb-highlight class="" [result]="documentSource">
                    </ngb-highlight>
                </p>
                
                <!-- for binding comments -->
                <!-- download single -->
                <!-- <div>
                <a class="btn btn-ico" (click)= "downloadSingleDocument(imageToOpen)">
                    <em class="fas fa-download fa-lg" ngbTooltip="{{'lblDownload' | translate}}" translate></em>
                </a>
                download multiple
                <a class="btn btn-ico" (click)= "downloadAllDocument()">
                    <em class="fas fa-file-download fa-lg" ngbTooltip="{{'lblDownloadAll' | translate}}"></em>
                </a>
            </div> -->
            </div>
        </ng-container>


    </div>
    <div class="modal-footer mt-25">
        <button (click)="OnClose()" class="btn btn-primary" aria-label="Center Align" translate>lblCancel</button>
    </div>
</div>
